import { audioProps } from '../interface';
import { WEb_SOCKET_URL } from '../../constants/constant';

const initAudioProps: audioProps = {
  action: 'SENDFOR_SPEECH',
};

export default function audioFun(message: string) {
  // 检测WebSocket是否已经正常启动
  if (!window._socket || window._socket?.readyState !== 1) {
    window._socket = new WebSocket(WEb_SOCKET_URL);
  }
  const audioParams: audioProps = {
    ...initAudioProps,
    message,
  };
  // 语音
  if (window._socket.readyState === 1) {
    window._socket.send(JSON.stringify(audioParams));
  }
  window._socket.onopen = () => {
    window._socket.send(JSON.stringify(audioParams));
  };
}
